import React from 'react';

const ModalSim = (props) => {
    return (
        <div className={"modal fade " + props.options.show} tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Asignar número</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.closeModal()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor="">Número telefónico</label>
                            <input type="text" name="numero"
                                id="numero"
                                className="form-control" value={props.options.numero || ""}
                                onChange={props.setNumberSim()} maxLength="10" />
                            <small>Número telefónico 10 digítos</small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Seleccione la Compañía del SIM</label>
                            <select name="company" id="company" className="form-control" onChangeCapture={props.setNumberSim()} value={props.options.company}>
                                <option value="telcel" >Telcel</option>
                                <option value="att" >AT&T</option>
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={props.closeModal()}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={props.saveNumberSim()}>Guardar número</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalSim;


// WEBPACK FOOTER //
// ./src/components/ModalSim.js